import React from 'react';

const HowItWorks = ({ onGetStarted }) => {
  const steps = [
    {
      id: 1,
      icon: 'fas fa-upload',
      title: 'Upload Your Bag',
      description: 'Take photos of your bag that you don\'t mind borrowing out. Our admin team will review and approve your listing.',
      color: '#d4af37'
    },
    {
      id: 2,
      icon: 'fas fa-search',
      title: 'Browse Available Purses',
      description: 'Explore purses from other users. Filter by size, condition, brand, and more to find your perfect match.',
      color: '#28a745'
    },
    {
      id: 3,
      icon: 'fas fa-exchange-alt',
      title: 'Request a Trade',
      description: 'Found a purse you like? Send a trade request with your bag and decide how long you would like to borrow each other\'s purse.',
      color: '#007bff'
    },
    {
      id: 4,
      icon: 'fas fa-handshake',
      title: 'Complete the Trade',
      description: 'Once both parties agree, arrange for company driver pickup or ship your bags. And at the end of the agreed time return each other\'s item. Then Leave reviews to build your reputation.',
      color: '#6f42c1'
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">Trading purses has never been easier</p>
        
        <div className="steps-grid-horizontal">
          {steps.map((step, index) => (
            <div key={step.id} className="step-card-horizontal">
              <div className="step-number">{index + 1}</div>
              <div className="step-icon" style={{ color: step.color }}>
                <i className={step.icon}></i>
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="how-it-works-footer">
          <h3>Ready to Start Trading?</h3>
          <p>Join thousands of purse enthusiasts who are already trading on our platform.</p>
          <button className="btn btn-primary" onClick={onGetStarted}>Get Started</button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 